import { Select } from 'foundations-components/transitional/components/Select';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { useObjectTypeDefinition, useObjectTypeDefinitionTranslationOptions } from 'crm-object-board-core/objectTypeDefinition';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ObjectTypeSelect = () => {
  const objectTypeId = useObjectTypeId();
  const objectTypeDefinition = useObjectTypeDefinition();
  const {
    objectName
  } = useObjectTypeDefinitionTranslationOptions();
  const options = useMemo(() => {
    if (!objectTypeDefinition) {
      return [];
    }
    return [{
      value: objectTypeDefinition.objectTypeId,
      text: objectName
    }];
  }, [objectTypeDefinition, objectName]);
  if (!objectTypeDefinition) {
    return null;
  }
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "crm-board-card-settings-object-type-select",
    options: options,
    value: objectTypeId,
    readOnly: true
  });
};